import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    wrapper: {
      padding: '32px 42px',
      boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      borderRadius: '16px',
      [theme.breakpoints.down(1200)]: {
        flexDirection: 'column',
      },
      height: '100%',
      position: 'relative',
    },
    quoteImage: {
      display: 'block',
      width: '59px',
      height: '51px',
    },
    quoteText: {
      fontSize: '21px',
      fontWeight: 500,
      lineHeight: '30px',
      marginTop: 0,
    },
    quoteAuthor: {
      fontSize: '13px',
      fontWeight: 400,
      lineHeight: '17px',
    },
    textWrapper: {
      [theme.breakpoints.up(1200)]: {
        padding: '0 12px',
      },
    },
    twitterQuoteText: {
      fontSize: '16px',
    },
    textTwitterWrapper: {
      padding: '0 12px',
    },
    twitterAuthor: {
      color: '#141619',
      margin: 0,
    },
    twitterHandle: {
      color: '#687684',
      margin: 0,
    },
    twitterImage: {
      position: 'absolute',
      top: '16px',
      right: '16px',
    },
    twitterText: {
      marginLeft: '10px',
    },
    headerWrapper: {
      display: 'flex',
    },
    twitterProfile: {
      borderRadius: '50%',
    },
  };
});

export const QuoteBox = ({ quote, author, stars }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <img className={classes.quoteImage} src="/img/hack-page/quote-icon.png" alt="Quote icon" />
      <div className={classes.textWrapper}>
        <p className={classes.quoteText}>{quote}</p>
        <p className={classes.quoteAuthor}>{author}</p>
        {stars && <img src={'/img/creators/stars.png'} />}
      </div>
    </div>
  );
};

export const TwitterBox = ({ quote, author, imgSrc, handle }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <div className={classes.textTwitterWrapper}>
        <div className={classes.headerWrapper}>
          <img className={classes.twitterProfile} width="55px" height="55px" src={imgSrc} />
          <div className={classes.twitterText}>
            <p className={classes.twitterHandle}>{handle}</p>
            <p className={classes.twitterAuthor}>{author}</p>
          </div>
        </div>
        <p className={classes.twitterQuoteText}>{quote}</p>
      </div>
      <img className={classes.twitterImage} src="/img/creators/twitter.svg" alt="Twitter icon" />
    </div>
  );
};
